module.exports = __webpack_public_path__ + "img/succeed.bab2137f.png";